export const ENV_DEV = 'development';
export const ENV_PROD = 'production';

const config = {
  [ENV_DEV]: {
    // apiBaseUrl: 'http://127.0.0.1:8000',
    apiBaseUrl: 'https://www.redstateaccess.com/api',
    contentBaseUrl: 'https://content.redstateaccess.com/api',
    assetsBaseUrl: 'https://content.redstateaccess.com/storage/uploads',
  },
  [ENV_PROD]: {
    contentBaseUrl: '/cms',
    apiBaseUrl: '/api',
    assetsBaseUrl: 'https://content.redstateaccess.com/storage/uploads',
  },
};

export default config[process.env.NODE_ENV || ENV_PROD];
